module.exports = __webpack_public_path__ + "static/media/Microf Statement of Terms and Conditions.0ac1e577.pdf";